// export const url = "https://sgi-server-multiple.herokuapp.com/api/v1"
// export const  url = "http://localhost:8000/api/v1"
// export const url = "https://usstripe.mozack.co/api/v1"
export const url = "https://usstripe.mozack.org/api/v1"
